(() => {
  const template = document.getElementById('doll-face-home-template');
  const root = document.getElementById('root');
  if (!template || !root) return;
  const mount = () => {
    const host = root.querySelector('.page-marketplace .store-body');
    const feature = document.getElementById('doll-face-home-feature');
    if (!host) {
      feature?.remove();
      return;
    }
    if (feature?.parentElement === host && host.firstElementChild === feature) return;
    feature?.remove();
    host.prepend(template.content.cloneNode(true));
  };
  new MutationObserver(mount).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  window.addEventListener('hashchange', mount);
  mount();
})();
